import { createContext } from 'react';

const isBrowser = () => typeof window !== 'undefined';

const userAgent = isBrowser() ? navigator.userAgent : '';

export const UserAgentContext = createContext(userAgent);
